import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import Seo from "@/components/Seo";
import { routePath } from "@/i18n/routes";
import { Kicker, PageHero, Section, CardGrid } from "@/components/Primitives";
import { Button } from "@/components/ui/button";

export default function HumanDevelopment() {
  const { t, lang } = useI18n();
  return (
    <div data-testid="human-development-page">
      <Seo pageKey="humanDev" />
      <PageHero kicker={t("humanDev.kicker")} title={t("humanDev.title")} lead={t("humanDev.lead")} />

      <Section>
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-7">
            <p className="text-base leading-relaxed text-foreground/90 sm:text-lg">{t("humanDev.p1")}</p>
            <p data-testid="human-dev-disclaimer" className="mt-8 border-l-2 border-accent pl-6 text-sm leading-relaxed text-muted-foreground">
              {t("humanDev.disclaimer")}
            </p>
          </div>
          <div className="md:col-span-5 flex items-start">
            <Button asChild size="lg" data-testid="human-dev-cta" className="rounded-full bg-accent px-8 text-accent-foreground hover:bg-accent/90">
              <Link to={routePath("apply", lang)}>{t("cta.apply")}</Link>
            </Button>
          </div>
        </div>
      </Section>

      <Section className="bg-secondary/40">
        <Kicker>{t("humanDev.itemsKicker")}</Kicker>
        <CardGrid items={t("humanDev.items")} testIdPrefix="human-dev-item" />
      </Section>
    </div>
  );
}
